var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.progressBarState
    ? _c("div", { staticClass: "progress-loader" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader--background" }, [
      _c("div", { staticClass: "loader--bar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }